import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

export function format(date: Date | string): string {
  return dayjs(date).format('YYYY/MM/DD')
}

export function age(date: Date | string): number | null {
  if (!age) return null
  return dayjs().diff(date, 'year')
}

// 当日が、開始・終了期間を含む期間内であったらtrue そうでなければfalseを返す
export function isBetweenToday(
  startedAtDate: Date | string,
  endedAtDate: Date | string
): boolean {
  dayjs.extend(isBetween)
  return dayjs().isBetween(dayjs(startedAtDate), dayjs(endedAtDate), null, '[)')
}

export function isExpired(date: Date | string): boolean {
  return dayjs().isAfter(dayjs(date))
}
